export const experienceData = [
    {
        id: 1,
        company: 'IETE, India Met Society, Telematic forum',
        jobtitle: 'Fellow of Computer Society of India',
        startYear: '0',
        endYear: '0'
    },
    {
        id: 2,
        company: 'Indian Science Congress (ISCA)',
        jobtitle: 'Life member',
        startYear: '0',
        endYear: '0'
    },
    {
        id: 3,
        company: 'Computer Society of India (CSI)',
        jobtitle: 'National president',
        startYear: '0',
        endYear: '0'
    },
    {
        id: 4,
        company: 'Indian Meteorological Society',
        jobtitle: 'President',
        startYear: '0',
        endYear: '0'
    },
    {
        id: 5,
        company: 'Indian Science Congress (ISCA)',
        jobtitle: 'President ICT Section',
        startYear: '0',
        endYear: '0'
    },
    {
        id: 6,
        company: 'International Federation of Information Processing',
        jobtitle: 'Vice-Chairman of TC5',
        startYear: '0',
        endYear: '0'
    },
    {
        id: 7,
        company: 'Gwalior Academy of Mathematical Sciences (GAMS)',
        jobtitle: 'President',
        startYear: '0',
        endYear: '0'
    },
    {
        id: 8,
        company: 'DU, GGS IPU and SBBS Institute of engineering & technology',
        jobtitle: 'Adjunct Professor in CS & Engineering',
        startYear: '0',
        endYear: '0'
    },
    {
        id: 9,
        company: 'Govt. Of India',
        jobtitle: 'Chairman of two Technical advisory committee of DST',
        startYear: '0',
        endYear: '0'
    },
    {
        id: 10,
        company: 'Mohyal Educational & Research Institute of Technology',
        jobtitle: 'Director',
        startYear: '0',
        endYear: '0'
    },
]